import React, { Component } from 'react';
//import { Route } from 'react-router';
import { Layout } from './components/Layout';
//import { Home } from './components/Home';
//import { FetchData } from './components/FetchData';
//import { Counter } from './components/Counter';
import Router from "./Router"
import { Formulario } from './components/Formulario';
//import { FormaPago } from './components/FormaPago';

import './custom.css'

//export default class App extends Component {
//  static displayName = App.name;

//  render () {
//    return (
//      <Layout>
//        <div>
//                <center>
//                    <h4 style={{ marginTop: "10px" }}>VI Congreso Internacional de Biotecnolog&iacute;a y Biodiversidad</h4>
//                    <h5>CIBB 2022</h5>
//                    <h5>- MODALIDAD VIRTUAL -</h5>
//                </center>
//                <br />
//                <h5>Formulario de Registro: VI CIBB 2022</h5>
//                <br />
//                <Formulario />
//                <Router /> 
//        </div>
//      </Layout>
//    );
//  }
//}

function App() {
    return (
        <>
            <Layout>
                <Router />                
            </Layout>            
        </>

    );
}

export default App;

